(function () {
  "use strict";

  const initVerticalSlideshow = (section) => {
    const swiperEl = section.querySelector(".swiper");
    if (!swiperEl) return;

    const dots = Array.from(section.querySelectorAll(".vss__dot-btn"));
    const prevBtn = section.querySelector('[data-action="prev"]');
    const nextBtn = section.querySelector('[data-action="next"]');
    const counterEl = section.querySelector("[data-vss-current]");
    const progressBar = section.querySelector(".vss__progress-line");
    const scrollHint = section.querySelector(".vss__scroll-hint");

    const autoplaySeconds = parseInt(section.dataset.autoplay, 10) || 0;
    const pauseOnVideo = section.dataset.pauseOnVideo === "true";

    const pad = (n) => String(n + 1).padStart(2, "0");

    let progressTimer = null;
    let previousIndex = 0;
    let holdingOnLastSlide = false;
    let holdStartTime = 0;
    let lastSlideReleased = false;
    let transitionCooldown = false;
    let lastWheelTime = 0;

    /* ── Trackpad / mouse-wheel detection ─────────────────── */
    let isTrackpad = false;
    let trackpadCheckCount = 0;

    function detectInputDevice(deltaY) {
      if (trackpadCheckCount < 5) {
        if (Math.abs(deltaY) < 50 && !Number.isInteger(deltaY / 120)) {
          isTrackpad = true;
        }
        trackpadCheckCount++;
      }
    }

    /* ── Accumulated delta for trackpad gesture recognition ── */
    let accumulatedDelta = 0;
    let accumulateTimer = null;
    const TRACKPAD_THRESHOLD = 80;
    const MOUSE_COOLDOWN = 800;
    const TRACKPAD_COOLDOWN = 600;

    function resetAccumulator() {
      accumulatedDelta = 0;
      accumulateTimer = null;
      lastSlideReleased = false;
    }

    /* ── Viewport checks ──────────────────────────────────── */
    function isSectionInView() {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function isSectionFullyVisible() {
      const rect = section.getBoundingClientRect();
      const visibleHeight =
        Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      return visibleHeight / window.innerHeight >= 0.96;
    }

    /* ── Progress bar ─────────────────────────────────────── */
    function startProgress() {
      if (!progressBar || !autoplaySeconds) return;
      section.classList.add("is-resetting");
      progressBar.getBoundingClientRect();
      section.classList.remove("is-resetting", "is-playing");
      progressBar.getBoundingClientRect();
      section.classList.add("is-playing");
      progressBar.style.transitionDuration = autoplaySeconds + "s";
    }

    function stopProgress() {
      if (!progressBar) return;
      section.classList.remove("is-playing");
      clearTimeout(progressTimer);
    }

    /* ── Swiper ───────────────────────────────────────────── */
    const swiper = new Swiper(swiperEl, {
      init: false,
      direction: "vertical",
      speed: 700,
      effect: "creative",
      creativeEffect: {
        prev: { shadow: true, translate: [0, "-10%", -1] },
        next: { translate: [0, "100%", 0] },
      },
      watchSlidesProgress: true,
      grabCursor: false,
      simulateTouch: true,
      touchRatio: 1,
      touchAngle: 45,
      threshold: 5,
      longSwipesRatio: 0.3,
      resistance: true,
      resistanceRatio: 0.65,
      touchReleaseOnEdges: true,
      slideToClickedSlide: false,
      mousewheel: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: false,
    });

    /* ── UI sync ──────────────────────────────────────────── */
    function updateUI(index) {
      const isLastSlide = index === swiper.slides.length - 1;
      dots.forEach((d, i) =>
        d.setAttribute("aria-current", i === index ? "true" : "false")
      );
      if (counterEl) counterEl.textContent = pad(index);
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = isLastSlide;
      if (scrollHint) scrollHint.style.opacity = index === 0 ? "" : "0";
      section.classList.toggle("user-has-scrolled", index !== 0);
    }

    /* ── Slide change events ──────────────────────────────── */
    swiper.on("slideChange", () => {
      const currentIndex = swiper.activeIndex;
      const isMovingForward = currentIndex > previousIndex;

      section.classList.toggle("is-scrolling-up", !isMovingForward);
      section.classList.toggle("is-scrolling-down", isMovingForward);

      previousIndex = currentIndex;
      updateUI(currentIndex);
      stopProgress();
      if (autoplaySeconds) startProgress();

      holdingOnLastSlide = false;
      lastSlideReleased = false;

      transitionCooldown = true;
      setTimeout(() => {
        transitionCooldown = false;
      }, swiper.params.speed + 100);
    });

    swiper.on("slideChangeTransitionEnd", () => {
      section.classList.remove("is-scrolling-up", "is-scrolling-down");
    });

    /* ── Single window-level wheel handler ────────────────── */
    window.addEventListener(
      "wheel",
      (e) => {
        if (!isSectionFullyVisible()) return;

        detectInputDevice(e.deltaY);

        const totalSlides = swiper.slides.length;
        const isLastSlide = swiper.activeIndex === totalSlides - 1;
        const isFirstSlide = swiper.activeIndex === 0;
        const isScrollDown = e.deltaY > 0;
        const isScrollUp = e.deltaY < 0;
        const cooldown = isTrackpad ? TRACKPAD_COOLDOWN : MOUSE_COOLDOWN;

// ── Scroll UP ────────────────────────────────────────
if (isScrollUp) {
  if (isFirstSlide) return; // release to page
  e.preventDefault();
  if (transitionCooldown) {
    // Drain inertia during cooldown so it doesn't carry into next gesture
    accumulatedDelta = 0;
    return;
  }

  if (isTrackpad) {
    accumulatedDelta += e.deltaY; // deltaY is negative
    clearTimeout(accumulateTimer);
    accumulateTimer = setTimeout(resetAccumulator, 150);

    if (accumulatedDelta > -TRACKPAD_THRESHOLD) return;
    accumulatedDelta = 0;
    clearTimeout(accumulateTimer);
  }

  const now = Date.now();
  if (now - lastWheelTime < cooldown) return;
  lastWheelTime = now;
  swiper.slidePrev();
  return;
}

        // ── Scroll DOWN ──────────────────────────────────────
        if (isScrollDown) {
          if (transitionCooldown) {
            e.preventDefault();
            return;
          }

          if (!isLastSlide) {
            e.preventDefault();

            if (isTrackpad) {
              accumulatedDelta += e.deltaY;
              clearTimeout(accumulateTimer);
              accumulateTimer = setTimeout(resetAccumulator, 150);

              if (accumulatedDelta < TRACKPAD_THRESHOLD) return;
              accumulatedDelta = 0;
              clearTimeout(accumulateTimer);
            }

            const now = Date.now();
            if (now - lastWheelTime < cooldown) return;
            lastWheelTime = now;
            swiper.slideNext();
            return;
          }

          // ── On last slide ─────────────────────────────────
          // Already released this gesture — don't re-engage
          if (lastSlideReleased) return;

          if (!holdingOnLastSlide) {
            e.preventDefault();
            holdingOnLastSlide = true;
            holdStartTime = Date.now();
            accumulatedDelta = 0;
            return;
          }

          // Absorb inertia — longer window for trackpad
          const elapsed = Date.now() - holdStartTime;
          const inertiaWindow = isTrackpad ? 600 : 200;
          if (elapsed < inertiaWindow) {
            e.preventDefault();
            return;
          }

          // Release — let page scroll naturally
          holdingOnLastSlide = false;
          lastSlideReleased = true;
        }
      },
      { passive: false }
    );

    /* ── Dot / arrow controls ─────────────────────────────── */
    if (prevBtn) prevBtn.addEventListener("click", () => swiper.slidePrev());
    if (nextBtn) nextBtn.addEventListener("click", () => swiper.slideNext());
    dots.forEach((dot) => {
      dot.addEventListener("click", () =>
        swiper.slideTo(parseInt(dot.dataset.index, 10))
      );
    });

    /* ── Autoplay ─────────────────────────────────────────── */
    function scheduleAutoplay() {
      if (!autoplaySeconds) return;
      if (pauseOnVideo) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const video = activeSlide?.querySelector("video");
        if (video && !video.muted) return;
      }
      startProgress();
      progressTimer = setTimeout(() => {
        if (swiper.activeIndex === swiper.slides.length - 1) {
          swiper.slideTo(0);
        } else {
          swiper.slideNext();
        }
      }, autoplaySeconds * 1000);
    }

    swiper.on("slideChangeTransitionEnd", scheduleAutoplay);

    /* ── Volume controls ──────────────────────────────────── */
    section.querySelectorAll("[data-slide-volume]").forEach((ctrl) => {
      const slide = ctrl.closest(".vss__slide");
      const video = slide?.querySelector("video");
      if (!video) return;
      const unmuteBtn = ctrl.querySelector('[data-action="unmute"]');
      const muteBtn = ctrl.querySelector('[data-action="mute"]');
      unmuteBtn?.addEventListener("click", () => {
        video.muted = false;
        unmuteBtn.hidden = true;
        if (muteBtn) muteBtn.hidden = false;
      });
      muteBtn?.addEventListener("click", () => {
        video.muted = true;
        muteBtn.hidden = true;
        if (unmuteBtn) unmuteBtn.hidden = false;
      });
    });

    /* ── Visibility change ────────────────────────────────── */
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopProgress();
      } else {
        scheduleAutoplay();
      }
    });

    /* ── Init ─────────────────────────────────────────────── */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        swiper.init();
        updateUI(0);
        scheduleAutoplay();
      });
    });
  };

  function tryInit() {
    if (typeof Swiper === "undefined") {
      setTimeout(tryInit, 50);
      return;
    }
    document.querySelectorAll(".vss").forEach(initVerticalSlideshow);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }
})();